// TODO: Add runner bios.

const RUNNERS = [
  {
    id: 'bramz',
    name: 'Bramz',
    lbmod: true,
    discordmod: true,
    began: 2014,
    bio: '',
    links: {
      bsky: 'bramz.live',
      srcom: 'Bramz',
      twitch: 'Bramz',
      youtube: 'c/BramzYT',
    },
    location: {
      country: 'USA',
      subcountry: 'Michigan'
    }
  }
];

export default RUNNERS;